export function load_status_delete(state = false, action) {
  if (action.type === 'SHOW_STATUS_LOAD') {
    return true;
  }
  if (action.type === 'HIDE_STATUS_LOAD') {
    return false;
  }
  return state;
}
